import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { MonthEndClosureProvider } from "presentation/store/MonthEndClosure/MonthEndClosureProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import MonthEndClosureMaintenance from "presentation/view/section/MonthEndClosure/MonthEndClosureMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const MonthEndClosureCont = () => {
    return <ANAInfoWrapper permission={Permission.MONTH_END_CLOSURE_MAINTENANCE}>
        <MessageBarWrapper>
            <MonthEndClosureProvider>
                <GridStyles />
                <MonthEndClosureMaintenance />
            </MonthEndClosureProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default MonthEndClosureCont;